import React, { useEffect } from "react";
import CustomInput from "common/components/CustomInput/CustomInput.jsx";

const EasyPhoneNumber = (props) => {
  const { propName } = props;
  const setPropMounted = props.connectForm.setPropMounted;

  useEffect(() => {
    setPropMounted(propName, true);
    return () => {
      setPropMounted(propName, false);
    };
  }, [setPropMounted, propName]);

  function transformPhoneNumber(value) {
    let returnValue = value;

    if (/[^0-9]/.test(returnValue.slice(-1))) {
      return returnValue.slice(0, -1);
    }

    if (/^\d$/.test(returnValue)) {
      return "(" + returnValue;
    }
    if (/^\(\d\d\d\d$/.test(returnValue)) {
      return returnValue.slice(0, 4) + ") " + returnValue.slice(4);
    }
    if (/^\(\d\d\d\) \d\d\d\d$/.test(returnValue)) {
      return returnValue.slice(0, 9) + "-" + returnValue.slice(9);
    }

    return returnValue;
  }

  return (
    <CustomInput
      success={props.connectForm.getState(propName) === "Success"}
      error={props.connectForm.getState(propName) === "Error"}
      labelText={
        <span>
          {props.connectForm.getLabel(propName) + " "}
          {props.connectForm.isRequired(propName) ? (
            <span style={{ color: "red" }}>*</span>
          ) : (
            ""
          )}
        </span>
      }
      id={propName}
      formControlProps={{
        fullWidth: true,
      }}
      inputProps={{
        type: "tel",
        onChange: (event) =>
          props.connectForm.change(
            transformPhoneNumber(event.target.value),
            propName
          ),
        value: props.connectForm.getValue(propName),
        autoComplete: "off",
      }}
    />
  );
};

export default EasyPhoneNumber;
